import {Pressable, View} from "react-native"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/src/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import {Text} from "shared/base"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

export default memo(shapeComponent(class ComponentsProUpgradeOverlayOptionBox extends ShapeComponent {
  static defaultProps = {
    buttonProps: undefined,
    first: false,
    focus: false,
    href: null,
    last: false,
    onButtonPress: null,
    onLayout: null,
    schoolPlan: false,
    target: null
  }

  static propTypes = propTypesExact({
    aboveButtonContent: PropTypes.func,
    buttonProps: PropTypes.object,
    buttonText: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    first: PropTypes.bool.isRequired,
    focus: PropTypes.bool.isRequired,
    href: PropTypes.string,
    identifier: PropTypes.string.isRequired,
    minHeight: PropTypes.number.isRequired,
    last: PropTypes.bool.isRequired,
    onButtonPress: PropTypes.func,
    onLayout: PropTypes.func,
    schoolPlan: PropTypes.bool.isRequired,
    target: PropTypes.string
  })

  render() { // eslint-disable-line complexity
    const {aboveButtonContent, buttonProps, buttonText, children, first, focus, href, last, minHeight, onButtonPress, schoolPlan, target} = this.p
    const defaultStyle = useMemo(() => ({
      Text: {
        color: focus ? "#fff" : "#2c2c96"
      }
    }), [focus])
    let backgroundColor

    if (focus) {
      backgroundColor = "#1b1f72"
    } else if (schoolPlan) {
      backgroundColor = "#f2f0ff"
    } else {
      backgroundColor = "#fff"
    }

    let ButtonComponent

    if (href) {
      ButtonComponent = Link
      buttonProps.to = href
      buttonProps.target = target
    } else if (onButtonPress) {
      ButtonComponent = Pressable
      buttonProps.onPress = onButtonPress
    } else {
      throw new Error("Couldn't figure out how to handle button")
    }

    return (
      <WithDefaultStyle style={defaultStyle}>
        <View
          dataSet={this.rootViewDataSet ||= {component: "pro--upgrade-overlay--option-box"}}
          onLayout={this.tt.onLayout}
          style={this.cache("rootViewStyle", {
            width: 300,
            minHeight: focus ? minHeight + 130 : minHeight,
            padding: 48,
            backgroundColor,
            borderLeft: !first && !focus ? "1px solid #cbc6ff" : undefined,
            borderTopLeftRadius: first || focus ? 48 : undefined,
            borderBottomLeftRadius: first || focus ? 48 : undefined,
            borderTopRightRadius: last || focus ? 48 : undefined,
            borderBottomRightRadius: last || focus ? 48 : undefined
          }, [first, focus, last, minHeight, schoolPlan])}
        >
          <View style={this.aboveButtonViewStyle ||= {marginBottom: 15}}>
            {aboveButtonContent()}
          </View>
          <ButtonComponent
            dataSet={this.pressableDataSet ||= {class: "option-box-button"}}
            style={this.cache("pressableStyle", {
              paddingTop: 16,
              paddingBottom: 16,
              backgroundColor: focus ? "#5253ff" : undefined,
              border: !focus ? "2px solid #2c2c96" : undefined,
              borderRadius: 22,
              textAlign: "center"
            }, [focus])}
            {...buttonProps}
          >
            <Text
              style={this.buttonTextStyle ||= {
                marginTop: "auto",
                marginBottom: "auto",
                color: focus ? "#fff" : "#2c2c96",
                fontWeight: "bold",
                textAlign: "center"
              }}
            >
              {buttonText}
            </Text>
          </ButtonComponent>
          <View style={this.childrenViewStyle ||= {marginTop: 15}}>
            {children}
          </View>
        </View>
      </WithDefaultStyle>
    )
  }

  onLayout = (e) => {
    const {identifier, onLayout} = this.p

    if (onLayout) {
      onLayout({e, identifier})
    }
  }
}))
